import React, { useEffect } from "react";
import { hot } from "./data";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const CityProjects = () => {
    const { city } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const cityProperties = hot.filter((property) =>
        property.location.toLowerCase().includes(city?.toLowerCase() || "")
    );



    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <>
            <Helmet>
                <title>Luxury Flats, Builder Floors & Villas in Delhi, Mumbai & Goa</title>
                <meta
                    name="description"
                    content="Explore residential & commercial real estate in Noida, Mumbai, Goa & more. Verified listings, top builders, 0% brokerage. Book your site visit today."
                />
            </Helmet>
            <div className="p-6 mt-16">
                <h1 className="text-3xl font-bold text-gray-800 text-center">
                    {city} Real Estate Projects
                </h1>
                <p className="text-lg text-gray-600 text-center my-2">
                    Explore premium properties and investment opportunities in {city}.
                </p>

                <div className="px-6 py-10 bg-gray-100">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {cityProperties.length > 0 ? (
                            cityProperties.map((data, index) => (
                                <div
                                    key={index}
                                    className="relative flex flex-col overflow-hidden rounded-xl bg-white shadow-lg transition-transform duration-300 cursor-pointer hover:scale-105"
                                    onClick={() => navigate(`${data.route}`)}
                                >
                                    <img src={data.img} alt={data.name} className="w-full h-60 object-cover" />
                                    <span className="absolute top-4 right-4 bg-gradient-to-r from-blue-500 to-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-md">
                                        {data.type}
                                    </span>

                                    <div className="p-3">
                                        <div className="flex items-center justify-between">
                                            <p className="text-xl font-semibold text-gray-900 uppercase">{data.name}</p>
                                        </div>
                                        <p className="text-gray-600 text-sm mb-1">{data.location}</p>
                                        <span className="bg-green-500 text-white px-2 text-xs py-1 rounded-full shadow-md">
                                            {[1, 15].includes(data.id) ? "Price Revealing Soon" : `Starts from ₹ ${data.price}`}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-span-4 text-center text-green-600 text-4xl font-bold py-10 animate-pulse transition-all duration-500">
                                Coming Soon...
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    );
};

export default CityProjects;
